import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from '../services/http/http.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(private http: HttpService) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const authToken = this.http.getToken() || ' ';

		const authRequest = req.clone({
			headers: req.headers.set('Authorization', 'Bearer ' + authToken),
		});
		return next.handle(authRequest);
	}
}
